<template>
 <div class="info">
    <div class="top">
      元数据信息
    </div>
    <div class="bottom">
      <div class="bottom-row">
        <span>著录号：</span>
        <span>{{taskDataInfo.descriptionNo}}</span>
      </div>
      <div class="bottom-row">
        <span>唯一标识符：</span>
        <span>{{taskDataInfo.gunongCode}}</span>
      </div>
      <div class="bottom-row">
        <span>古农书ID：</span>
        <span>{{taskDataInfo.gunongshuId}}</span>
      </div>
      <div class="bottom-row">
        <span>分类：</span>
        <span>{{taskDataInfo.classify}}</span>
      </div>
      <div class="bottom-row">
        <span>子课题：</span>
        <span>{{taskDataInfo.studyName}}</span>
      </div>
      <div class="bottom-row">
        <span>题名：</span>
        <span>{{taskDataInfo.metaTitle}}</span>
      </div>
      <div class="bottom-row">
        <span>其他题名信息：</span>
        <span>{{taskDataInfo.metaTitleOther}}</span>
      </div>
      <div class="bottom-row">
        <span>主要责任者：</span>
        <span>{{taskDataInfo.personLiableOther}}</span>
      </div>
      <div class="bottom-row">
        <span>版本：</span>
        <span>{{taskDataInfo.version}}</span>
      </div>
      <div class="bottom-row">
        <span>点校信息：</span>
        <span>{{taskDataInfo.checkInfo}}</span>
      </div>
      <div class="bottom-row">
        <span>收藏单位：</span>
        <span>{{taskDataInfo.organizationFrom}}</span>
      </div>
      <div class="bottom-row">
        <span>备注：</span>
        <span>{{taskDataInfo.remark}}</span>
      </div>
      <div class="bottom-row">
        <span>类型：</span>
        <span>{{taskDataInfo.metaType == 0 ? '底本' : taskDataInfo.metaType == 1 ? '校本' : taskDataInfo.metaType == 2 ? '普通版本' : ''}}</span>
      </div>
      <div class="bottom-row">
        <span>摘要：</span>
        <span>{{taskDataInfo.metaSummary}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['taskDataInfo']
}
</script>
<style lang="less">
.info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-sizing: border-box;
  position: relative;

  .top {
    width: 100%;
    min-height: 50px;
    background: #FEF6EA;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #523D28;
  }

  .bottom {
    flex: 1;
    background: #fff;
    padding: 25px 20px 10px 20px;

    &-row {
      text-align: start;
      margin-bottom: 10px;
      
      span:nth-child(1) {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a0a0a0;
      }

      span:nth-child(2) {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
      }

      div {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #CBAB7A;
        display:  inline-block;
        margin-right: 10px;
      }

      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #947243;
        display:  inline-block;
      }
    }
  }
}
</style>